import { Button } from "./ui/Button";

interface Props {
  ready: boolean;
  error: string | null;
  onConnect: () => void;
}

export function Connect({ ready, error, onConnect }: Props) {
  return (
    <div className="connect">
      <h1 className="app__title">Task dashboard</h1>
      <p className="connect__text">
        Connect the Google account that owns the spreadsheet to load and edit your
        tasks.
      </p>
      <Button variant="primary" onClick={onConnect} disabled={!ready}>
        {ready ? "Connect with Google" : "Loading…"}
      </Button>
      {error && <p className="notice" style={{ marginTop: 20 }}>{error}</p>}
    </div>
  );
}
